export const commaSeparatedStringsToArray = (string: string) => {
  return string.split(',').map(function (item) {
    return item.trim();
  });
};
